import React, { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { useOrganization } from './OrganizationContext'
import { useAuth } from '../hooks/useAuth'
import { getCurrentSubscription, getCurrentUsage } from '../lib/supabase'
import { computeEntitlements } from '../lib/entitlements'

const EntitlementsContext = createContext(null)

export function EntitlementsProvider({ children }) {
  const { org } = useOrganization()
  const { isPlatformAdmin } = useAuth()
  const [subscription, setSubscription] = useState(null)
  const [usage, setUsage] = useState(null)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    const orgId = org?.id
    if (!orgId) { setSubscription(null); setUsage(null); setLoading(false); return }
    setLoading(true)
    const [subRes, usageRes] = await Promise.all([
      getCurrentSubscription(orgId),
      getCurrentUsage(orgId),
    ])
    setSubscription(subRes?.data || null)
    setUsage(usageRes?.data || null)
    setLoading(false)
  }, [org?.id])

  useEffect(() => { load() }, [load])

  const ent = computeEntitlements({ subscription, usage, isPlatformAdmin })
  const value = { ...ent, loading, refresh: load }
  return <EntitlementsContext.Provider value={value}>{children}</EntitlementsContext.Provider>
}

export const useEntitlements = () => {
  const ctx = useContext(EntitlementsContext)
  if (ctx === null) throw new Error('useEntitlements must be used within EntitlementsProvider')
  return ctx
}
